import { render } from "./OmnichannelOverviewTable.vue?vue&type=template&id=a2dd72b4&scoped=true"
import script from "./OmnichannelOverviewTable.vue?vue&type=script&lang=js"
export * from "./OmnichannelOverviewTable.vue?vue&type=script&lang=js"

import "./OmnichannelOverviewTable.vue?vue&type=style&index=0&id=a2dd72b4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dd72b4"]])

export default __exports__